import { render, staticRenderFns } from "./kllk-header-nav.vue?vue&type=template&id=2cf81fdc&scoped=true"
import script from "./kllk-header-nav.vue?vue&type=script&lang=js"
export * from "./kllk-header-nav.vue?vue&type=script&lang=js"
import style0 from "./kllk-header-nav.vue?vue&type=style&index=0&id=2cf81fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf81fdc",
  null
  
)

export default component.exports